/**
 * @generated SignedSource<<10de4b79573005ebc1834efdefe21245>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ItemAssociationType = "group" | "item" | "mixed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpRespLayout_viewer$data = {
  readonly itemRead: ReadonlyArray<{
    readonly displayInfo?: {
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_displayInfo">;
    } | null;
    readonly serviceId?: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_item">;
  } | null> | null;
  readonly personalizedItemsList?: {
    readonly associationType: ItemAssociationType | null;
    readonly hasPersonalizedItem: boolean | null;
  } | null;
  readonly similarLandingItems?: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_similarLandingItems">;
  } | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_user" | "PdpSharedLayout_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_viewer" | "PdpSharedLayout_viewer">;
  readonly " $fragmentType": "PdpRespLayout_viewer";
};
export type PdpRespLayout_viewer$key = {
  readonly " $data"?: PdpRespLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespLayout_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v1 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "isTopYmalVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespContainer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedLayout_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedLayout_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_item"
            },
            {
              "condition": "isClient",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "buyerId",
                      "variableName": "userId"
                    },
                    {
                      "kind": "Literal",
                      "name": "page",
                      "value": "pdp"
                    }
                  ],
                  "concreteType": "ItemDisplayInfo",
                  "kind": "LinkedField",
                  "name": "displayInfo",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespContainer_displayInfo"
                    }
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "isTopYmalVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "fetchPdp",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "similarLandingItems",
              "args": [
                {
                  "kind": "Literal",
                  "name": "auctionModule",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 6
                },
                {
                  "kind": "Variable",
                  "name": "isTrade",
                  "variableName": "isTrade"
                },
                (v1/*: any*/),
                {
                  "kind": "Literal",
                  "name": "onlyAuctionItems",
                  "value": true
                }
              ],
              "concreteType": "moreLikeThisItemConnection",
              "kind": "LinkedField",
              "name": "moreLikeThisItem",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_similarLandingItems"
                }
              ],
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "personalizedItemsList",
          "args": [
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "pageSize",
              "value": 10
            },
            (v0/*: any*/)
          ],
          "concreteType": "PersonalizedItems",
          "kind": "LinkedField",
          "name": "personalizedItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "associationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPersonalizedItem",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "598959642c77de80b15109f40a574eaf";

export default node;
